import { render, staticRenderFns } from "./tickertape.vue?vue&type=template&id=bac0885e&scoped=true"
import script from "./tickertape.vue?vue&type=script&lang=js"
export * from "./tickertape.vue?vue&type=script&lang=js"
import style0 from "./tickertape.vue?vue&type=style&index=0&id=bac0885e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bac0885e",
  null
  
)

export default component.exports